import { useEffect, useState } from 'react';
import type { ApiClient } from '../../api/client';

/**
 * Refus visibles d'avance (ADR-100 ; ADR-149, addendum du 2026-10-20) : la page demande au serveur,
 * par `GetCommandAccess`, si la politique accorde chaque commande qu'elle présente, pour griser le
 * bouton et dire pourquoi **avant** la saisie. Présentation seulement : le serveur reste juge à
 * l'exécution. Tant que la réponse n'est pas là, ou si elle échoue, rien n'est grisé : le refus du
 * serveur s'affichera comme avant.
 */

export const NOT_PERMITTED = 'Votre rôle ne permet pas cette action.';

export interface CommandAccess {
  /** `false` : refusée d'avance ; `true` ou inconnue : présentée. */
  allowed(commandName: string | undefined): boolean;
}

export function useCommandAccess(client: ApiClient, names: readonly (string | undefined)[]): CommandAccess {
  const wanted = [...new Set(names.filter((name): name is string => name !== undefined))].sort();
  const key = wanted.join(',');
  const [denied, setDenied] = useState<ReadonlySet<string>>(new Set());
  useEffect(() => {
    if (key === '') return;
    let alive = true;
    client
      .query<{ commands?: Array<{ command_name: string; allowed: boolean }> }>('GetCommandAccess', { command_names: key })
      .then((response) => alive && setDenied(new Set((response.data.commands ?? []).filter((entry) => !entry.allowed).map((entry) => entry.command_name))))
      .catch(() => alive && setDenied(new Set()));
    return () => {
      alive = false;
    };
  }, [client, key]);
  return { allowed: (name) => name === undefined || !denied.has(name) };
}
